import ExpensePage from "@/pages/ExpensePage";
export default function Mira() {
  return (
    <ExpensePage
      category="mira"
      title="MIRA"
      subtitle="Tasse maldiviane (MIRA) — importo mensile inserito manualmente"
    />
  );
}
